import upload from "../../../public/static/images/svg/uploadSVG.svg";
import Images from "../UserInterface/Images";
import React, { useState, useEffect } from "react";
import fetch from "../../utils/fetch";
import { encrypt } from "../../utils/cipher";
import GC from "react-google-recaptcha";
import Router from "next/router";
import {
  isEmailFormat,
  isEmpty,
  isCharLengthValid,
  isPhoneNumberFormat,
  isPhoneNumberLengthValid
} from "../../utils/validator";
import { InputForm, TextArea } from "../../components/UserInterface/InputForm";
import { scrollTo } from "../../utils/scroll-to";
import { GACustomEvent } from "src/utils/analytics";
import Description from "../../components/UserInterface/Description";


const ContactForm = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [file, setFile] = useState("");
  const [capt, setCapt] = useState(false);
  const [errorCapt, setErrorCapt] = useState("");
  const [fileName, setFileName] = useState("Lampirkan Berkas");
  const [errorName, setErrorName] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [errorPhone, setErrorPhone] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);
  const [btnSubmit, setBtnSubmit] = useState("Kirim");
  const [fileSizeIsValid, setFileSizeIsValid] = useState(true);
  const [fileSizeErrorMessage, setFileSizeErrorMessage] = useState("");
  const [msgResponse, setMsgResponse] = useState(null);

  useEffect(() => {
    name && phone && email && message
      ? setIsDisabled(false)
      : setIsDisabled(true);
  }, [name, phone, email, message]);

  useEffect(() => {
    if (capt) {
      setErrorCapt("");
    }
  }, [capt]);

  const getAndSetBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.readAsDataURL(img);
    reader.onload = () => {
      callback(reader.result);
    };
  };
  const validateName = (e) => {
    const val = e;
    setErrorName("");

    if (isEmpty(val)) {
      setErrorName("Nama Lengkap Wajib Diisi");
      return false;
    } else if (!isCharLengthValid(val)) {
      setErrorName("Nama Lengkap Harus Terdiri Dari 3 - 25 Karakter");
      return false;
    }
    return true;
  };

  const handelPhoneNumber = (e) => {
    const re = /^[0-9]{1,13}$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      setErrorPhone("");
      setPhone(e.target.value);
    }
  };

  // isMain | Boolean -> main phone number is cannot be empty
  // val | String -> the input value
  // errorSetter | function -> function that set the error message content
  // valueStter | function -> function that set input value
  const validatePhoneNumber = (e) => {
    const val = e;
    setErrorPhone("");
    if (isEmpty(val)) {
      setErrorPhone("Nomor Handphone Wajib Diisi");
      return false;
    }

    //only check if value is not empty so the error message
    //will not be triggered when the input is not mandatory
    if (!isEmpty(val)) {
      if (isNaN(val)) {
        setErrorPhone("Nomor Handphone Harus Berupa Angka");
        setPhone("");
      } else if (!isPhoneNumberLengthValid(val)) {
        setErrorPhone("Nomor Handphone Harus Terdiri Dari 10 - 13 Angka");
        return false;
      } else if (!isPhoneNumberFormat(val)) {
        setErrorPhone("Format Nomor Handphone Tidak Sesuai");
        return false;
      }
    }
    return true;
  };

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  const validateEmail = (e) => {
    const val = e;
    setErrorEmail("");

    if (isEmpty(val)) {
      setErrorEmail("Email Wajib Diisi");
      return false;
    } else if (!isEmailFormat(val)) {
      setErrorEmail("Format Email Tidak Sesuai");
      return false;
    }
    return true;
  };

  const validateMessage = (e) => {
    setErrorMsg("");

    if (isEmpty(e)) {
      setErrorMsg("Pesan Wajib Diisi");
      return false;
    }
    return true;
  };
  const handleFile = (e) => {
    setFileSizeErrorMessage("");

    if (e.target.files[0].size / 1000 < 2000) {
      setFileSizeIsValid(true);
      getAndSetBase64(e.target.files[0], (value) => {
        setFile(value);
      });
      setFileName(e.target.files[0].name);
    } else {
      setFileSizeErrorMessage("File Tidak Boleh Berukuran Lebih Dari 2MB");
      setFileSizeIsValid(false);
    }
  };
  const handleGc = (e) => {
    if (e) {
      setCapt(true);
    }
  };

  const validateGC = (val) => {
    setErrorCapt("");

    if (!val) {
      setErrorCapt("Bagian Ini Wajib Diisi");
      return false;
    }

    return true;
  };

  const validateForm = () => {
    if (
      !validateName(name) ||
      !validatePhoneNumber(phone) ||
      !validateEmail(email) ||
      !validateMessage(message) ||
      !validateGC(capt) ||
      !fileSizeIsValid
    ) {
      scrollToError();
      return false;
    }

    return true;
  };

  const resetForm = () => {
    setName("");
    setPhone("");
    setEmail("");
    setMessage("");
    setFile("");
    setCapt("");
  };

  const scrollToError = () => {
    const elem = document.getElementsByClassName("input--error")[0];
    if (!elem) {
      return;
    }
    const topPos = elem.offsetParent.offsetTop;
    scrollTo(document.scrollingElement, topPos - 300, 600);
  };

  const handleSubmit = async () => {
    const date = new Date();
    let id = `MEROWEB${date.getFullYear()}${date.getMonth()}${date.getDate()}${date.getHours()}${date.getMinutes()}${date.getSeconds()}${date.getMilliseconds()}`;
    if (!validateForm()) return;

    if (!isDisabled && capt === true && isEmailFormat(email)) {
      setBtnSubmit("Mengirim ...");
      setIsDisabled(true);

      const inputData = {
        name: name,
        phone: phone,
        message: message,
        email: email,
        file: file,
        preferd: "Phone || Email",
        messageId: id
      };

      const { data, status } = await fetch("POST", `/form/hubungi-kami`, {
        data: encrypt(inputData)
      });

      if (status === 200) {
        await Router.push({
          pathname: "/thank-you",
          query: { form: "hubungi-kami" }
        });
        GACustomEvent("contact_us_page_submit_form", "click");
        resetForm();
        window.grecaptcha.reset();
        window.scroll(0, 0);
        setFileName("Lampirkan Berkas");
      } else {
        setBtnSubmit("Gagal Mengirim");
        setTimeout(() => {
          setIsDisabled(false);
          setBtnSubmit("Coba Lagi");
        }, 3000);
        setMsgResponse(data.message);
      }
    }
  };

  return (
    <div className="contact-us-wrapper">
      <form>
        <InputForm
          onChange={(e) => setName(e.target.value)}
          onBlur={(e) => validateName(e.target.value)}
          value={name}
          type="text"
          title="Nama Lengkap"
          placeholder="Nama Lengkap"
          errMsg={errorName}
          formTitleFontSize="14px"
        />
        <InputForm
          onChange={handelPhoneNumber}
          onBlur={(e) => validatePhoneNumber(e.target.value)}
          value={phone}
          type="tel"
          title="Nomor Handphone"
          placeholder="Harus diawali dengan 08 atau 628"
          pattern="^\d{2}-\d{3}$"
          errMsg={errorPhone}
          formTitleFontSize="14px"
        />
        <InputForm
          onChange={handleEmail}
          onBlur={(e) => validateEmail(e.target.value)}
          value={email}
          type="email"
          title="Alamat Email"
          placeholder="Alamat Email"
          errMsg={errorEmail}
          formTitleFontSize="14px"
        />
        <TextArea
          onChange={(e) => setMessage(e.target.value)}
          onBlur={(e) => validateMessage(e.target.value)}
          placeholder="Informasikan pesan/kronologi yang ingin disampaikan"
          value={message}
          title="Pesan Anda"
          formTitleFontSize="14px"
          errMsg={errorMsg}
        ></TextArea>
        
        <Description
          font="Roboto"
          align="left"
          fontSize="14px"
          width="calc(100% + 64px)"
          margin="0 -32px"
          marginMobile="0"
          text="Jika memiliki nomor kontrak wajib menuliskan tanggal lahir & nama Ibu Kandung"
        />

        <div htmlFor="upload-input" className="upload-component">
          {fileSizeErrorMessage ? (
            <p style={{ color: "#e11931" }}>{fileSizeErrorMessage}</p>
          ) : (
            ""
          )}
          <label className="label-upload" htmlFor="upload-input">
            <Images width="64px" url={upload} />
            <input
              id="upload-input"
              className="upload-input"
              type="file"
              onChange={(e) => handleFile(e)}
            />
            {fileName}
          </label>
          <i>Ukuran maksimal 2MB</i>
        </div>
        <div className="captcha-component">
          <GC
            onChange={(e) => handleGc(e)}
            sitekey={process.env.captchaKey}
          ></GC>
        </div>

        {errorCapt && <label className="error">{errorCapt}</label>}
      </form>
      {isDisabled ? (
        <button className="button-submit button-red-disabled">
          {btnSubmit}
        </button>
      ) : (
        <button className="button-submit" onClick={handleSubmit}>
          {btnSubmit}
        </button>
      )}
      {msgResponse != null ? (
        <div className="info">{msgResponse}</div>
      ) : (
        <div className="info">
          Tinggalkan informasi kamu dan kami akan menghubungi kamu sesegera
          mungkin
        </div>
      )}

      <style jsx>{`
        .contact-us-wrapper {
          width: 50%;
          margin: 16px;
        }
        .upload-component {
          margin: 16px 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 16px;
          background: var(--color-white-soft);
          border-radius: 8px;
          border: dashed 2px var(--color-gray-medium);
        }
        .upload-input {
          display: none;
        }
        .label-upload {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        .label-upload:hover {
          cursor: pointer;
        }
        .error {
          height: 16px;
          color: var(--color-red);
          font-size: 14px;
          font-weight: normal;
          text-align: center;
        }
        .button-red-disabled {
          color: #fff;
          cursor: not-allowed !important;
        }
        .info {
          background-color: var(--color-gray);
          border-radius: 8px;
          color: var(--color-white);
          margin: 16px 0;
          padding: 16px;
          box-shadow: 0 2px 4px 0 rgba(64, 64, 64, 0.4);
        }

        button {
          background-color: var(--color-red);
          font-weight: bold;
          border: none;
          color: white;
          padding: 16px 24px;
          border-radius: 8px;
          margin: 32px 0 16px 0;
        }
        button:hover {
          cursor: pointer;
        }
        .captcha-component {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        form {
          display: flex;
          flex-direction: column;
          margin-top: 16px;
        }
        @media only screen and (max-width: 740px) {
          .contact-us-wrapper {
            width: 100%;
          }
          p,
          i {
            font-size: 12px;
          }
          button {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};
export default ContactForm;
